import './FadingDivider.css';

export default function FadingDivider() {
    return <hr className='fading-divider' />;
}
